import { Component, ViewChild } from '@angular/core';
import { PoBreadcrumb, PoUploadComponent, PoNotificationService, PoTableColumn } from '@po-ui/ng-components';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { of } from 'rxjs';

@Component({
  selector: 'app-comparacao-arquivos',
  templateUrl: './comparacao-arquivos.component.html',
  styleUrls: ['./comparacao-arquivos.component.css'],
  standalone: false,
})
export class ComparacaoArquivosComponent {
  @ViewChild('original', { static: true }) original!: PoUploadComponent;
  @ViewChild('portal', { static: true }) portal!: PoUploadComponent;

  loading = false;
  grupos: string = '5010,5310';
  tolerancia: number = 0;
  itemsProcessados: any[] = [];
  processamentoConcluido = false;
  arquivosSelecionados = false;

  restrictions = { allowedExtensions: ['.txt'] };
  urlPlaceholder = 'https://po-ui.io';

  columns: Array<PoTableColumn> = [
    { property: 'reg', label: 'Registro' }, 
    { property: 'coD_ITEM', label: 'Código Item' },
    { property: 'quanT_INI_ORIGINAL', label: 'Quantidade Inicial 1' },
    { property: 'cuS_INI_ORIGINAL', label: 'Custo Inicial 1' },
    { property: 'icmS_INI_ORIGINAL', label: 'ICMS Inicial 1' },
    { property: 'quanT_FIM_ORIGINAL', label: 'Quantidade Fim 1' },
    { property: 'cuS_FIM_ORIGINAL', label: 'Custo Fim 1' },
    { property: 'icmS_FIM_ORIGINAL', label: 'ICMS Fim 1' },
    { property: 'quanT_INI_PORTAL', label: 'Quantidade Inicial 2' },
    { property: 'cuS_INI_PORTAL', label: 'Custo Inicial 2' },
    { property: 'icmS_INI_PORTAL', label: 'ICMS Inicial 2' },
    { property: 'quanT_FIM_PORTAL', label: 'Quantidade Fim 2' },
    { property: 'cuS_FIM_PORTAL', label: 'Custo Fim 2' },
    { property: 'icmS_FIM_PORTAL', label: 'ICMS Fim 2' },
    { property: 'quanT_INI_DELTA', label: 'Quantidade Inicial Diferença' },
    { property: 'cuS_INI_DELTA', label: 'Custo Inicial Diferença' },
    { property: 'icmS_INI_DELTA', label: 'ICMS Inicial Diferença' },
    { property: 'quanT_FIM_DELTA', label: 'Quantidade Fim Diferença' },
    { property: 'cuS_FIM_DELTA', label: 'Custo Fim Diferença' },
    { property: 'icmS_FIM_DELTA', label: 'ICMS Fim Diferença' },
    { property: 'onlY_IN', label: 'Apenas nesse' },
  ];

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'CAT 83/2009' },
      { label: 'Comparação de arquivos' }
    ]
  };

  constructor(
    private http: HttpClient,
    private notification: PoNotificationService
  ) { }

  verificarArquivosSelecionados() {
    const original = this.original?.currentFiles;
    const portal = this.portal?.currentFiles;
    this.arquivosSelecionados = !!(original?.length && portal?.length);
  }

  processar() {
    const original = this.original?.currentFiles;
    const portal = this.portal?.currentFiles;

    if (!original?.length || !portal?.length) {
      this.notification.warning('Selecione os dois arquivos para prosseguir com a comparação.');
      return;
    }

    this.loading = true;

    const formData = new FormData();
    formData.append('Original', original[0].rawFile!, original[0].name);
    formData.append('Portal', portal[0].rawFile!, portal[0].name);

    this.http
      .post(`${environment.apiUrl}/v1/tools/fechamento-por-produto?grupos=${this.grupos}&tolerancia=${this.tolerancia}`, formData)
      .subscribe({
        next: (res: any) => {
          this.itemsProcessados = res.linhas;
          this.processamentoConcluido = true;
          this.notification.success('Comparação realizada com sucesso.');
          this.loading = false;
        },
        error: (err: any) => {
          this.notification.error(`Erro ao processar: ${err.message}`);
          this.loading = false;
          return of(null);
        }
      });
  }

  reiniciarProcesso() {
    this.itemsProcessados = [];
    this.processamentoConcluido = false;
    this.arquivosSelecionados = false;
    this.original.clear();
    this.portal.clear();
    this.tolerancia = 0;
    this.grupos = '5010,5310';
  }
}